import { getCountries, getCountryCallingCode, type CountryCode } from 'libphonenumber-js/max';

export type PhoneCountry = {
    iso: CountryCode;
    label: string;
    callingCode: string;
    flagClass: string;
};

function getCountryName(iso: CountryCode, locale: string = 'fr'): string {
    try {
        const displayNames = new Intl.DisplayNames([locale], { type: 'region' });
        return displayNames.of(iso) || iso;
    } catch {
        return iso;
    }
}

export function getPhoneCountries(locale: string = 'fr'): PhoneCountry[] {
    return getCountries()
        .map((iso) => ({
            iso,
            label: getCountryName(iso, locale),
            callingCode: `+${getCountryCallingCode(iso)}`,
            flagClass: `fi fi-${iso.toLowerCase()}`
        }))
        .sort((a, b) => a.label.localeCompare(b.label, locale));
}